import { render, staticRenderFns } from "./add-edit-client.vue?vue&type=template&id=5313f872&scoped=true&"
import script from "./add-edit-client.vue?vue&type=script&lang=js&"
export * from "./add-edit-client.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-client.vue?vue&type=style&index=0&id=5313f872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313f872",
  null
  
)

component.options.__file = "add-edit-client.vue"
export default component.exports